import { computed } from '@angular/core';
import { signalStore, withComputed, withState } from '@ngrx/signals';
import { withCrudMethods } from '../../store/crud.feature';
import { EventService } from '../../services';
import { initialState } from '../../store/initial-state';
import { EventDTO } from '../../model';

const initEventState = initialState<EventDTO>();

export const EventStore = signalStore(
  { providedIn: 'root' },
  withState(initEventState),
  withCrudMethods(EventService),
  withComputed(({ entities }) => ({
    ev: computed(() => entities().sort((a, b) => b.id - a.id).slice(0, 10)),
  })),
);
